export default class Cards {
    constructor(module) {
        this.module = module;
        this.listedContentCards = this.module.querySelectorAll(".card-listed-content")
        this.resize = this.resizeHandler(() => this.resizeCards(), 1000)
        if(this.listedContentCards){
            if(window.innerWidth >= 992){
                this.setCardsHeight("listedContentCards");
            }
        }
        this.events();
    }
    events() {
        window.addEventListener("resize", () => this.resize())
    }

    // Makes all card heights the same
    setCardsHeight(card_name){            
        const cardHeights = [];
        if(this[card_name].length > 1){
            this[card_name].forEach( card => {
                cardHeights.push(card.offsetHeight)
            })
            const highest = cardHeights.reduce((a,b) => Math.max(a, b));                
            this[card_name].forEach( card => {
                card.style.height = `${highest}px`;
            })
        }
    }

    // Unset the set height
    unsetCardsHeight(card_name){            
        const cardHeights = [];
        if(this[card_name].length > 1){               
            this[card_name].forEach( card => {
                card.style.height = `unset`;
            })
        }
    }

    // Handle card resize on screen resize
    resizeCards(){
        if(this.listedContentCards){
            this.unsetCardsHeight("listedContentCards");
            this.setCardsHeight("listedContentCards");
        }
    }

    // Delay the card resize when resizing screen
    resizeHandler(callback, delay){
        let myTimeout;
        return () => {
            clearTimeout(myTimeout);
            myTimeout = setTimeout(() => {
                callback()
            }, delay);
        };
    }
}